import { Result } from "domain/entities/result";
import { DrugFoodInteractionRepository } from "domain/repositories";

export default class DeleteUseCase {
    private drugFoodInteractionRepository: DrugFoodInteractionRepository;
    
    public constructor(drugFoodInteractionRepository: DrugFoodInteractionRepository) {
        this.drugFoodInteractionRepository = drugFoodInteractionRepository
    }

    public async deleteDrugFoodInteraction(id: number, token: Promise<[string | null, string | null]>): Promise<[Result, null] | [null, Error]> {
        const [t, ] = await token;
        if (t !== null) {
            return this.drugFoodInteractionRepository.deleteDrugFoodInteraction(id, t);
        } else {
            return [null, new Error("Autenticación faltante")];
        }
    }
}